import Core from './Core';

class Exporter {
  static Instance = new Exporter();

  async ExportCSV(table, user_dealerships = null) {
    let address = Core.Address + 'Export' + table;

    if (user_dealerships) {
      address += '?user_dealerships='+user_dealerships;
    }

    let options = {
      method: 'GET',
      mode: 'cors',
    };

    if (address.indexOf(Core.Address) != -1) {
      let token = Core.Instance.user != null ? Core.Instance.user.token : null;
      if (options.headers == null) options.headers = { 'X-Authorization': 'Token ' + token };
      else options.headers['X-Authorization'] = 'Token ' + token;
    }

    let chunks = [];
    let response = await fetch(address, options);
    const reader = response.body.getReader();
    const contentLength = response.headers.get('Content-Length');

    let receivedLength = 0;
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        break; //Sortie de la boucle
      }
      chunks.push(value);
    }

    let blob = new Blob(chunks);

    // Create blob link to download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'Export-' + table + '.csv');
    //Append to html page
    document.body.appendChild(link);
    //Force download

    link.click();
    // Clean up and remove the link
    link.parentNode.removeChild(link);
  }
}

export default Exporter;



// WEBPACK FOOTER //
// ./src/Core/Exporter.js